import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import {http,baseURL} from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import zhCN from 'vant/lib/locale/lang/zh-CN';
import zhTW from 'vant/lib/locale/lang/zh-TW';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
import { getLocale, getVantLocale, VANT_LOCALE } from './common/locale'
Vue.prototype.$http = http
Vue.prototype.$baseURL = baseURL
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)

// 站点语言：默认美式英语，不随浏览器语言切换，也没有切换入口
// 语言开关见 src/common/locale.js 的 SITE_LOCALE（'en' | 'zh-CN' | 'zh-TW'）
const initialLocale = getLocale();

const i18n = new VueI18n({
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: {
    'en': require('./assets/languages/en.json'),
    'zh-CN': require('./assets/languages/zh-CN.json'),
    'zh-TW': require('./assets/languages/zh-TW.json'),
  }
});

// Vant 组件内置文案（下拉刷新 / 加载中 / 没有更多了 / 弹窗按钮等）跟随站点语言
// 说明：只做 Vant 内置文案的语言映射，不改变语言切换策略与默认语言逻辑
Locale.add({ 'zh-CN': zhCN, 'zh-TW': zhTW, 'en-US': enUS });
function syncVantLocale(lang) {
  Locale.use(VANT_LOCALE[lang] || getVantLocale());
}
syncVantLocale(i18n.locale);
Vue.prototype.$syncVantLocale = syncVantLocale;

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
